import React from 'react'
import _ from 'lodash'
import { cn } from '../../lib/utils'
import NavLink from './NavLink'
import { useNav } from './NavProvider'

const NavGroup = ({ section }) => {
  const { isExpanded, meetsMinimumProgramLevel, hasProgramLevel } = useNav()
  const className = isExpanded ? '' : 'items-center'
  const containerClasses = cn('flex flex-col gap-1', className)
  const { theme, hideCollapsed, programLevel } = section
  let extraClasses = ''
  switch (theme) {
    case 'green':
      extraClasses = 'text-intoo-green-coachcta'
      break
    case 'deloitte':
      extraClasses = 'text-black bg-white'
  }

  if (
    !meetsMinimumProgramLevel(programLevel) ||
    (!isExpanded && hideCollapsed)
  ) {
    return null
  }
  if (
    !_.isEmpty(section.exactProgramLevel) &&
    !hasProgramLevel(section.exactProgramLevel)
  ) {
    return null
  }
  const collapsedTitle = section.collapsedTitle || section.title
  const showDivider = section.showDivider === false ? false : true
  const showHeader = section.showHeader === false ? false : true

  return (
    <>
      {showDivider && <NavDivider />}
      <div className={containerClasses}>
        {showHeader && (
          <NavGroupHeader className={extraClasses}>
            {isExpanded ? section.title : collapsedTitle}
          </NavGroupHeader>
        )}
        {section.children.map(
          (item, index) =>
            !item.hidden && <NavLink key={index} item={item} theme={theme} />,
        )}
      </div>
    </>
  )
}
export default NavGroup

const NavDivider = ({ className }) => {
  const classes = cn(
    'nav-divider my-4 h-[0.125rem] rounded-sm bg-cod-gray-50',
    className,
  )
  return <div className={classes}></div>
}

const NavGroupHeader = ({ className, children }) => {
  const { isExpanded } = useNav()
  const expandedClasses = isExpanded ? '' : 'px-0 text-[10px]'
  const headerClasses = cn(
    'w-11 text-center px-3 py-2 text-sm font-medium uppercase tracking-wide text-intoo-blue-medium ml-4',
    expandedClasses,
    className,
  )
  return <div className={headerClasses}>{children}</div>
}
